import { Cloudfront } from "../../../redux/data/globalData/cloudfront/cloudfrontActions"

export type ParseImageUrl = (fileId: string, width?: number) => string

export const parseImageUrl = (cloudfront: Cloudfront): ParseImageUrl => (fileId: string, width?: number): string => {
    const { signedFiles, signedImages } = cloudfront

    const isRegularUrl = fileId.startsWith('http')
    if (isRegularUrl) {
        return fileId
    }

    const cleanFileId = fileId.replace('fileId=', '')
    if (width) {
        return signedImages.replace('*', `fit-in/${width}x0/${cleanFileId}`)
    }

    return signedFiles.replace('*', encodeURIComponent(cleanFileId))
}